import React from 'react';

import { Box, Typography } from '@mui/material';
import cx from 'classnames';
import { Link } from 'react-router-dom';

import useStyles from './styles';

export interface CategoryLabelProps {
  name: string;
  bgColor?: string;
  textColor?: string;
  wrapperClass?: string;
  textClass?: string;
  url?: string | null;
  withDots?: boolean;
  textMaxWidth?: number;
  Icon?: React.FC<any>;
  iconProps?: {
    [x: string]: any;
  };
}

const CategoryLabel: React.FC<CategoryLabelProps> = ({
  name,
  bgColor,
  textColor,
  wrapperClass = '',
  textClass = '',
  url = '',
  withDots = true,
  textMaxWidth,
  Icon,
  iconProps = {},
  ...rest
}) => {
  const classes = useStyles(bgColor, textColor, textMaxWidth)();

  if (url) {
    return (
      <Link
        data-testid={rest['data-testid']}
        className={cx(classes.categoryLabel, wrapperClass)}
        to={url}
      >
        {Icon && <Icon {...iconProps} className={cx(classes.icon, iconProps?.className)} />}
        <Typography className={cx(classes.categoryTitle, textClass, withDots && classes.withDots)}>
          {name}
        </Typography>
      </Link>
    );
  }

  return (
    <Box data-testid={rest['data-testid']} className={cx(classes.categoryLabel, wrapperClass)}>
      {Icon && <Icon {...iconProps} className={cx(classes.icon, iconProps?.className)} />}
      <Typography className={cx(classes.categoryTitle, textClass, withDots && classes.withDots)}>
        {name}
      </Typography>
    </Box>
  );
};

export default CategoryLabel;
